import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { faCircleChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy } from '@fortawesome/sharp-regular-svg-icons';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import TrackerChallengeBox from '../../challenges/components/TrackerChallengeBox.js';
import { Button } from '../../shared/components/button/Button.tsx';
import { useHttpClient } from '../../shared/hooks/http-hook';
import { shouldShowChallengeOnTracker } from '../../shared/util/challenges.js';
import Influencers from '../components/Influencers';
import TrackerHeading from '../components/TrackerHeading';
import WaterIntake from '../components/WaterIntake';

function WaterTracker(props) {
  const { t } = useTranslation();
  const pageid = window.location.pathname;
  const healthArea = pageid.split('/')[1];
  const challenge = useSelector((state) => state?.challenges?.challenge);
  const { sendRequest } = useHttpClient();
  const [isSaved, setIsSaved] = useState(false);
  const [date, setDate] = useState(false);
  const [data, setData] = useState(null);
  const [currentTracker, setCurrentTracker] = useState(null);
  const [journal, setJournal] = useState(null);

  const getData = async (date) => {
    if (date.length > 0) {
      try {
        const response = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/trackers/hydration/${date}`
        );

        if (response && response.tracker?._id) {
          const { tracker } = response;
          setCurrentTracker({
            id: tracker._id,
            trackerDate: tracker.tracker_date.toString().slice(0, 10),
          });
          const data = JSON.parse(tracker.data);
          setData(data);
          setJournal({
            enhancers: tracker.enhancers,
            inhibitors: tracker.inhibitors,
            journal: tracker.journal,
          });
          setIsSaved(true);
        } else {
          setCurrentTracker({
            id: '',
            trackerDate: date,
          });
          setData({
            hydration: 5,
          });
          setJournal(() => ({
            enhancers: [],
            inhibitors: [],
            journal: '',
          }));
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  useEffect(() => {
    getData(date);
  }, [date]);

  const saveResponse = (location, stat) => {
    if (location === 'journal') {
      setJournal((prevState) => {
        return {
          ...prevState,
          [stat.id]: stat.value,
        };
      });
    } else {
      setData((prevState) => {
        return {
          ...prevState,
          [stat.id]: stat.value,
        };
      });
    }
  };

  const sendData = async () => {
    let method = 'POST';
    let url = `${process.env.REACT_APP_BACKEND_URL}/trackers/`;
    if (currentTracker.id !== '') {
      method = 'PUT';
      url = `${process.env.REACT_APP_BACKEND_URL}/trackers/${currentTracker.id}`;
    }

    try {
      const response = await sendRequest(
        url,
        method,
        JSON.stringify({
          trackerDate: date,
          type: 'hydration',
          data,
          hidden: false,
          enhancers: journal.enhancers,
          inhibitors: journal.inhibitors,
          journal: journal.journal,
          platform: 'web',
        })
      );
      if (response) {
        setIsSaved(true);

        props.closeTrackers();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    sendData();
  };

  return (
    <div
      id="snm-hydration"
      className="tracker-container"
      role="region"
      aria-label={`${t('T135')} ${t('tracker.region.title')}`}
    >
      <form className="tracker-form" onSubmit={handleSubmit} noValidate={false}>
        <div className="trackers-inner">
          <div className="back-to-main">
            <button
              className="back-btn"
              aria-label={t('A136')}
              title={t('A136')}
              onClick={props.handleBackToMain}
              type="button"
            >
              <FontAwesomeIcon icon={faCircleChevronLeft} />
            </button>
          </div>
          <TrackerHeading title="T138" setDate={setDate} isSaved={isSaved} />
          <div className="trackers-body" role="group" aria-label={t('modal.tracker.details')}>
            {shouldShowChallengeOnTracker(healthArea, challenge?.type, challenge?.isActive) && (
              <TrackerChallengeBox />
            )}
            <div className="ind-tracker" role="group" aria-labelledby="hydration-intake-title">
              <h2 className="title" id="hydration-intake-title">
                {t('T164')}
                {shouldShowChallengeOnTracker(healthArea, challenge?.type, challenge?.isActive) && (
                  <div className="tc-badge">
                    <FontAwesomeIcon icon={faTrophy} /> <p>{t('T017')}</p>
                  </div>
                )}
              </h2>
              <div className="buffer" />
              <WaterIntake
                questionid="hydration"
                data={data}
                saveResponse={saveResponse}
                required
              />
              <div className="buffer" />
            </div>
            <div className="ind-tracker" role="group" aria-labelledby="hydration-influencers-title">
              <div className="tracker-content-heading">
                <h2 className="title" id="hydration-influencers-title">
                  {t('T165')}
                </h2>
                <p className="optional-text">{t('T019')}</p>
              </div>
              <Influencers
                hydration
                questionid={['enhancers', 'inhibitors']}
                data={journal}
                saveResponse={saveResponse}
                greenListAriaLabel={t('trackers.influencers.waterMotivators')}
                redListAriaLabel={t('trackers.influencers.waterBlockers')}
              />
            </div>
          </div>
        </div>
        <div className="buttons">
          <Button type="button" onClick={props.closeTrackers} variant="secondary" color="dark">
            {t('T015')}
          </Button>
          <Button type="submit" icon={{ faIconDefinition: faArrowRight }} iconPosition="right">
            {t('T016')}
          </Button>
        </div>
      </form>
    </div>
  );
}
export default WaterTracker;
